import { useRef, useState } from "react"
import SearchInput from "../../../../components/form/search-input"
import AuthLayout from "../../../../components/layouts/auth"
import { useBusinessTransaction } from "../../../../composables/business-merchant/useBusinessTransaction"
import { numberWithCommas } from "../../../../lib/helper-support"
import TableSkeleton from "../../../../components/loader/table-placeholder-loader"
import { Link } from "react-router-dom"
import Naira from "../../../../components/naira"
import { Minus } from "lucide-react"
import { BusinessTransactionProps } from "../../../../types/business-merchant-type"
import moment from "moment"
import TransactionStatusBadge from "../../../../components/ui/transaction-status-badge"
import TablePagination from "../../../../components/table/table-pagination"

const BusinessTransction = () => {
    const [currentPage, setCurrentPage] = useState<number>(1);

    const [search, setSearch] = useState<string>('');

    const [showFilters, setShowFilters] = useState<boolean>(false);

    const showFiltersRef = useRef<HTMLDivElement>(null);

    const { data: transactionData, isLoading: loadingTransactions } = useBusinessTransaction({
        search,
        page: currentPage
    })

    return (
        <AuthLayout>
            <div>
                <div className='items-center justify-between space-y-5 md:flex md:space-y-0'>
                    <div className='flex items-center space-x-6'>
                        <h1 className='page-title'>Transactions</h1>
                        <span className='text-tertiary font-[600] text-[14px]'>{numberWithCommas(transactionData?.total ?? 0)} transactions</span>
                    </div>
                </div>
                <div className='relative'>
                    <div className='items-center justify-between w-full mt-2 space-y-5 lg:space-y-0 lg:flex'>
                        <SearchInput placeholder='Find Transaction' value={search} onChangeInput={(e) => setSearch(e.target.value)} />

                    </div>
                    {/* table */}
                    <div className='relative overflow-x-auto'>
                        <table className='mt-10 text-tertiary font-[600] text-[14px] w-full relative z-10 whitespace-nowrap'>
                            <thead>
                                <tr className='border-b border-[#E6EAF0]'>
                                    <td className="px-2 py-3">
                                        {/* <input type='checkbox' /> */}
                                    </td>
                                    <td className="px-4 py-3">Date</td>
                                    <td className="px-6 py-3">Reference</td>
                                    <td className="px-6 py-3">Status</td>
                                    <td className="px-6 py-3">Merchant</td>
                                    <td className="px-6 py-3">Type</td>
                                    <td className="px-6 py-3">Infrastructure</td>
                                    <td className="px-6 py-3">Settled Amount</td>
                                    <td className="px-6 py-3">Cashir Charge</td>
                                </tr>
                            </thead>
                            <tbody>
                                {loadingTransactions && <TableSkeleton numberOfColumns={10} />}
                                {!loadingTransactions && transactionData?.items?.map((transaction: BusinessTransactionProps, index: number) => (
                                    <tr key={index}
                                        className='border-b border-[#E6EAF0] relative'
                                    // style={{ backgroundColor: selectedTransactions.includes(transaction.reference) ? '#E6EAF0' : '' }}
                                    >
                                        <td className="px-2 py-3">
                                            {/* <input onChange={(event) => onSelectedTransaction(event)} value={transaction.reference} type='checkbox' className='relative z-10' /> */}
                                            <Link to={`/business-transactions/${transaction.reference}`} className='absolute top-0 bottom-0 left-0 w-full h-full hover:bg-[#E6EAF0] opacity-[0.2]' />
                                        </td>
                                        <td className="px-4 py-3">{moment(transaction.created_at).format('h:mm a, MMM D')}</td>
                                        <td className="px-6 py-3 capitalize">{transaction.reference ?? '-'}</td>
                                        <td className="px-6 py-3">
                                            <TransactionStatusBadge status={transaction.status} />
                                        </td>
                                        <td className="px-6 py-3 capitalize">{transaction.merchant.business_name ?? '-'}</td>
                                        <td className="w-fit px-6 py-3">
                                            <div className='flex bg-[#F8FAFB] justify-center w-full py-2 px-6 rounded-full'>
                                                <span className='first-letter:capitalize'>{transaction.type}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-3 capitalize">{transaction.provider ?? 'Cashir'}</td>
                                        <td className="px-6 py-3"><Naira />{numberWithCommas(transaction.settled_amount || 0)}</td>
                                        <td className="px-6 py-3 capitalize"><Naira /> {numberWithCommas(transaction.charge_amount || 0)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {!loadingTransactions && (
                        <div className='mt-5'>
                            <TablePagination
                                totalPages={transactionData?.totalPages ?? 0}
                                onPageChange={(page) => setCurrentPage(page)}
                                currentPage={transactionData?.page}
                            />
                        </div>
                    )}
                </div>
            </div>
        </AuthLayout>
    )
}

export default BusinessTransction